import { render, staticRenderFns } from "./fromItem.vue?vue&type=template&id=57c5ed16&scoped=true&"
import script from "./fromItem.vue?vue&type=script&lang=js&"
export * from "./fromItem.vue?vue&type=script&lang=js&"
import style0 from "./fromItem.vue?vue&type=style&index=0&id=57c5ed16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5ed16",
  null
  
)

export default component.exports